import * as React from 'react'
import { Link } from 'react-router-dom'

export const NoMatch: React.FunctionComponent = () => {
    return <div className={'ttg-page no-match'}>
        <main>
            <div className={'card'}>
                <div>Не удаётся найти такую страницу</div>
                <Link to={'/'}>Перейти на главную страницу</Link>
            </div>
        </main>
    </div>
}
